import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "transactions-table" }
const _hoisted_2 = { class: "amount" }
const _hoisted_3 = { class: "transaction-type" }
const _hoisted_4 = { class: "transaction-type" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = {
  key: 0,
  class: "no-transactions"
}

import { ref } from 'vue'
import { DateTime } from 'luxon'

interface Transaction {
  id: string
  amount: number
  status: string
  payriff_type: string
  type: string
  description?: string
  created_at: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TransactionsTable',
  props: {
    transactions: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const loading = ref(props.loading || false)

const formatDateTime = (dateString: string) => {
  if (!dateString) return '-'
  try {
    return DateTime.fromISO(dateString).toLocaleString({
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return 'Invalid date'
  }
}

const formatAmount = (amount: number) => {
  if (amount === null || amount === undefined) return '0.00'
  return (amount / 100).toFixed(2)
}

const getStatusType = (status: string) => {
  const statusMap: Record<string, string> = {
    PENDING: 'warning',
    APPROVED: 'success',
    FAILED: 'danger',
    CANCELLED: 'info',
  }
  return statusMap[status] || 'info'
}

const getStatusText = (payriff_type: string) => {
  const statusMap: Record<string, string> = {
    FREEZE: 'freeze',
    UNFREEZE: 'unfreeze',
    CHARGE: 'charge',
    COMPLETE: 'complete',
    AUTO_PAY: 'auto-pay',
    CAPTURE: 'capture',
    REFUND: 'refund',
    REVERSE: 'reverse',
    PRE_REVERSE: 'pre-reverse',
    VERIFY: 'verify',
    CANCELLED: 'Cancelled',
  }
  return statusMap[payriff_type] || payriff_type
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.transactions,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "Transaction Date",
          "min-width": "180"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(formatDateTime(scope.row.created_at)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Amount",
          "min-width": "120"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_2, "₼" + _toDisplayString(formatAmount(scope.row.amount)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Status",
          "min-width": "120"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.payriff_type), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Order Status",
          "min-width": "120"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.order_status), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Type",
          "min-width": "120"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(scope.row.type), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Description",
          "min-width": "200"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(scope.row.description || '-'), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, props.loading]
    ]),
    (_ctx.transactions.length === 0 && !props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[0] || (_cache[0] = [
          _createElementVNode("p", null, "No transactions found", -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}
}

})